import { render, staticRenderFns } from "./articleRecipeBlock.vue?vue&type=template&id=6882585f&"
import script from "./articleRecipeBlock.vue?vue&type=script&lang=js&"
export * from "./articleRecipeBlock.vue?vue&type=script&lang=js&"
import style0 from "./articleRecipeBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports